import { Navigate, RouteObject } from 'react-router-dom'
import AdminLayout from './components/AdminLayout'
import AdminDashboardPage from './pages/AdminDashboardPage'
import CreateOperatorPage from './pages/CreateOperatorPage'
import ManageOperatorsPage from './pages/ManageOperatorsPage'
import UpdateOperatorPage from './pages/UpdateOperatorPage'
import ManageDomainsPage from './pages/ManageDomainsPage'
import CryptoInvoicesPage from '../crypto-invoices/pages/CryptoInvoicesPage'

const adminRoutes: RouteObject = {
	path: '/admin',
	element: <AdminLayout />,
	children: [
		{
			index: true,
			element: <Navigate to="/admin/dashboard" />,
		},
		{
			path: '/admin/dashboard',
			element: <AdminDashboardPage />,
		},
		{
			path: '/admin/manage-operators',
			element: <ManageOperatorsPage />,
		},
		{
			path: '/admin/create-operator',
			element: <CreateOperatorPage />,
		},
		{
			path: '/admin/update-operator/:id',
			element: <UpdateOperatorPage />,
		},
		{
			path: '/admin/manage-domains',
			element: <ManageDomainsPage />,
		},
		{
			path: '/admin/crypto-invoices',
			element: <CryptoInvoicesPage />,
		},
	],
}

export default adminRoutes
